import DefaultFormat from './default_format.helper'
import { strToTime } from '../style_string.helper'

export default class PaulinaZarrabeFormat extends DefaultFormat {
  formatGuardianCSV () {
    const { guardian } = this.jsonObj
    const g = guardian?.toLowerCase().trim()
    if (g === undefined || g === '' || g === null || g === 'no') return 'No'
    return 'Si'
  }

  formatLab () {
    const { lab } = this.jsonObj
    const l = lab?.toLowerCase().trim()
    if (l === undefined || l === '' || l === null || l === 'no' || l === 'n') return false
    return true
  }

  formatRadiography () {
    const { radiography } = this.jsonObj
    const r = radiography?.toLowerCase().trim()
    if (r === undefined || r === '' || r === null || r === 'no' || r === 'n') return false
    return true
  }

  formatImplant () {
    const { implant } = this.jsonObj
    const i = implant?.toLowerCase().trim()
    if (i === undefined || i === '' || i === null || i === 'no' || i === 'n') return false
    return true
  }

  formatTimeCSV () {
    const { time } = this.jsonObj
    if (time === undefined) throw new Error('No se encontró el campo de hora.')
    if (time === '') return ''
    if (time.includes('AM') || time.includes('PM')) return time // Time is already formatted
    const formatTime = strToTime(time)
    const ampm = formatTime.split(' ')[1]
    const hour = parseInt(formatTime.split(':')[0])
    if (!(hour === 12 && ampm === 'PM') &&
      ((hour === 12 && ampm === 'AM') ||
      (hour < 6 && ampm === 'AM') ||
      (hour >= 8 && ampm === 'PM'))
    ) {
      throw new Error('La hora de la cita esta fuera de horario')
    }
    return formatTime
  }

  formatGovtId () {
    const { govtId } = this.jsonObj
    if (!govtId) return undefined
    return govtId.toString().trim()
  }

  formatDuration () {
    const { duration } = this.jsonObj
    if (!duration) return 60
    const parsed = parseInt(duration.toString().trim(), 10)
    return parsed > 0 ? parsed : 60
  }

  formatContactCSV () {
    const { contact, radiography, implant } = this.jsonObj
    if (radiography.toLowerCase().trim() === 'si' || implant.toLowerCase().trim() === 'si') return 'No'
    const c = contact?.toLowerCase().trim()
    if (c === undefined ||
      c === '' ||
      c === null ||
      c === 'si'
    ) return 'Si'
    return 'No'
  }
}
